import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '../mui/Core/index'
import { useTheme } from '../mui/Styles/index'

function SubHeader(props) {
  const theme = useTheme()
  const { title } = props

  const subHeaderStyle = {
    fontSize: '1.563rem',
    color: `${theme.palette.primary.main} !important`,
    fontFamily: 'SanomatMedium',
  }

  return <Typography sx={subHeaderStyle}>{title}</Typography>
}
SubHeader.propTypes = {
  title: PropTypes.string.isRequired,
}

export default SubHeader
